import React, { useEffect } from "react"
import Layout from "~/components/Layout";
import { useLang } from "~/hooks/useLang";
import AuditDispatchStatisticsReportTable from "../components/DispatchStatistics";

export default function AuditDispatchStatisticsReport() {
    const { translate } = useLang();

    useEffect(() => {
        document.title = translate('Dispatch Statistics report Audit - Dispatch System')
    }, [])
    return (
        <Layout marginLayout={true}>
            <AuditDispatchStatisticsReportTable />
        </Layout>
    )
}